<template>
  <b-card>
    <div slot="header" style="padding: 4px">
      <strong>Mensajes</strong>
    </div>

    <!-- Agregar un mensaje de advertencia/información si es_new es true y subject es 5: "Evaluación de ingreso" -->
    <b-alert v-if="is_new && subject == 5" variant="info" show>
      <p class="text-center m-0">
        <i class="fa fa-info-circle"></i>
        Se requiere adjuntar la FDS para continuar con el proceso.
      </p>
    </b-alert>

    <b-form
        @submit.prevent="guardarObs"
        name="ticketObservacionForm"
        data-vv-scope="ticketObservacionForm"
    >

      <!-- Input de Mensaje -->
      <b-row>
        <b-col cols="12">
                <span class="text-danger span-error small">{{
                    errors.first("ticketObservacionForm.observación")
                  }}</span>
          <b-form-textarea
              id="textarea"
              name="observación"
              v-validate="'required|max:5000'"
              v-model="selectedObservacion.observacion"
              placeholder="Escribe tu mensaje aquí..."
              rows="6"
              max-rows="8"
          ></b-form-textarea>
          <p class="text-right mt-1 mr-1"><span class="text-muted ">{{ quantityCharacters }}/5000</span></p>
        </b-col>
      </b-row>

       <!-- Switch para mostrar mensajes predeterminados -->
       <b-row class="align-items-center mb-3" v-if="validarPermisoComponente('tickets-mensajes-predeterminados')">
         <b-col>
           <div class="d-flex align-items-center">
             <label for="mostrarMensajesPredeterminados" class="mb-0 mr-3">Mensajes Predeterminados</label>
             <b-form-radio-group
               id="mostrarMensajesPredeterminados"
               name="mostrarMensajesPredeterminados"
               @change="toggleMensajesPredeterminados"
               v-model="mostrarMensajesPredeterminados"
               :options="opciones"
               buttons
               :button-variant="mostrarMensajesPredeterminados ? 'outline-primary' : 'outline-secondary'"
             />
           </div>
         </b-col>
       </b-row>
      
      <!-- Tabla de Mensajes Predeterminados -->
      <b-row v-if="validarPermisoComponente('tickets-mensajes-predeterminados') && mostrarMensajesPredeterminados == 1">
        <b-col cols="12">
          <b-table
            bordered
            responsive
            striped
            hover
            small
            :items="mensajesMasivos.data"
            :fields="columnas"
            empty-text="No hay mensajes predeterminados disponibles"
            thead-tr-class="table-active"
          >
            <template v-slot:cell(marcar)="data">
              <el-checkbox
                :value="obtenerValor(data.item)"
                @change="obtenerMensaje(data.item, $event)"
              ></el-checkbox>
            </template>
          </b-table>
          <el-pagination
            v-model="filtrosListas.page"
            class="float-right w-100 d-flex justify-content-end"
            :page-sizes="[10, 30, 50, 100]"
            :current-page="filtrosListas.page"
            :page-size="filtrosListas.perPage"
            @size-change="setPerPagePaginationMasivo"
            @current-change="setPagePaginationMasivo"
            layout="total, prev, pager, next"
            :total="mensajesMasivos.total"
            small
          />
        </b-col>
      </b-row>
      
      <br/>
      <b-row>
        <b-col cols="7">
          <b-form-file
              id="adjunto"
              ref="attachment"
              placeholder="Selecciona un archivo"
              type="file"
              name="adjunto"
              browse-text="Buscar"
              @change="uploadFile()"
          >
          </b-form-file>
        </b-col>
        <b-col cols="5">
          <b-button
              variant="primary"
              class="align-middle"
              style="display: block; vertical-align: middle"
              type="submit"
          >
            <i class="fa fa-paper-plane fa-lg"> </i>
            Enviar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <br/>
    <div v-if="observaciones.length">
      <h2 class="lead"><b class="font-weight-bold">Asunto:</b> {{ ticket_detalle.asunto }}</h2>
      <p class="lead mb-1"><b class="font-weight-bold">Creado por:</b> {{ observaciones[0].nombre }} (<span class="font-italic"> {{ ticket_detalle.created_at }}</span> )</p>
      <p class="lead mb-1"><b class="font-weight-bold">Empresa:</b> {{ ticket_detalle.empresa }}</p>

      <h3 class="lead my-4">Historial de respuestas:</h3>
      <ol class="comment-list">
        <li class="comment" v-for="item in observaciones" :key="item.id">
          <article class="comment-body">
            <footer class="comment-meta">
              <div class="comment-author">
                <img alt="" height="50"
                     src="img/userdefault.png"
                     width="50" class="avatar">
                <b class="fn"><a href="#" rel="external" class="url">{{ item.nombre }}</a></b>
              </div>
              <div>
                <small class="d-flex justify-content-between">
                  <time>
                    <i class="fa fa-clock-o"/>
                    <span class="font-italic"> {{ item.created_at }}</span>
                  </time>
                  <time v-if="item.leido">
                    <i class="fa fa-check-square text-success"/>
                    <span class="font-italic"> {{ item.fecha_leido }}</span>
                  </time>
                </small>
              </div>
            </footer>
            <div class="comment-content">
                <ObservationReadMore :observation="item.observacion" :itemKey="item.id"/>
              <b-button v-if="item.adjunto != null"
                        v-b-tooltip.hover
                        title="Descargar Adjunto"
                        variant="primary"
                        size="sm"
                        @click="descargaAdjunto(item, 'ticketObs')"
              >
                <i class="fa fa-download fa-lg icon"/>
                Descargar
              </b-button>

            </div>
          </article>

        </li>
      </ol>
    </div>
  </b-card>

</template>

<script>
import Vue from "vue";
import {ClientTable, Event} from "vue-tables-2";
import {mapState, mapActions, mapMutations} from "vuex";
import loader from "./../../containers/loader";
import Treeselect from "@riophae/vue-treeselect";
import VeeValidate, {Validator} from "vee-validate";
import es from "vee-validate/dist/locale/es";
import ObservationReadMore from "@/views/tickets/ObservationReadMore";
import { validarPermisoComponente } from '../../plugins/acl';

Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});
Validator.localize("es", es);

export default {
  props: {
    company_id: {
      type: [Number,String],
      required: true
    },
    is_new: {
      type: Boolean,
      required: false,
      default: false
    },
    subject: {
      type: [Number,String],
      required: false,
      default: 0
    }
  },
  name: "Observaciones",
  components: {
    ClientTable,
    Event,
    loader,
    Treeselect,
    ObservationReadMore
  },
  data() {
    return {
      mostrarMensajesPredeterminados: 0,
      opciones: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
      columnas: [
        {
          key: "marcar",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { "max-width": "50px", width: "50px !important" },
        },
        {
          key: "lista",
          label: "Observación",
          sortable: true,
        },
      ],
      validarPermisoComponente: validarPermisoComponente,
    }
  },
  computed: {
    ...mapState("tickets", [
      "selectedObservacion",
      "observaciones",
      "ticket_detalle",
      "mensajesMasivos",
      "filtrosListas"
    ]),
    quantityCharacters(){
      return this.selectedObservacion.observacion.length;
    },
  },
  methods: {
    ...mapActions("tickets", [
      "guardaObservacion",
      "descargarAdjunto",
      "setPerPagePaginationMasivo",
      "setPagePaginationMasivo",
      "listarListasPorCodigo"
    ]),
    ...mapMutations("dashboard", ["load"]),
    toggleMensajesPredeterminados() {
      // Método para manejar el cambio del switch
    },
    uploadFile(event) {
        const input = this.$refs.attachment.$el.querySelector('input[type="file"]');
        const maxSizeMB = 10;
        const maxSizeByte = maxSizeMB * 1024 * 1024;
        const file = input.files[0];
        if (file && file.size > maxSizeByte) {
            this.$alertError(`Èl tamaño maximo para cargar archivos son ${maxSizeMB} MB`,4000);
            input.value = "";
        }
    },
    async guardarObs(event) {
      this.$validator
          .validateAll("ticketObservacionForm")
          .then(async (result) => {
            if (result) {
              this.load(true);
              const input = this.$refs.attachment.$el.querySelector('input[type="file"]');
              const file = input.files[0];
              const formData = new FormData();
              if(file !== undefined)formData.append("file", file);
              formData.append("company_id", this.company_id);
              await this.guardaObservacion(formData)
                .then(()=>this.$refs.attachment.reset())
                .catch((error)=>this.$alertError(error.message));
              this.load(false);
            }
          });
    },
    obtenerValor(observacion) {
      return this.selectedObservacion.observacion == observacion.lista;
    },
    async obtenerMensaje(observacion, state) {
      if (!state) {
        this.selectedObservacion.observacion = "";
      } else {
        this.selectedObservacion.observacion = observacion.lista;
      }
    },
    async descargaAdjunto(adj, tipo = "ticket") {
      adj.tipo = tipo;
      await this.descargarAdjunto(adj);
    }
  },
  async created() {
    await this.listarListasPorCodigo(this.filtrosListas);
  },
  beforeDestroy() {
    // Limpiar validaciones de manera segura
    try {
      if (this.$validator) {
        // Limpiar campos específicos del scope
        if (this.$validator.fields && this.$validator.fields.items) {
          this.$validator.fields.items.forEach(field => {
            if (field.scope === 'ticketObservacionForm') {
              this.$validator.fields.remove(field.id);
            }
          });
        }
        // Limpiar errores
        this.$validator.errors.clear();
      }
    } catch (error) {
      console.warn('Error cleaning validator:', error);
    }
    
    // Limpiar referencias del archivo
    try {
      if (this.$refs.attachment) {
        this.$refs.attachment.reset();
      }
    } catch (error) {
      console.warn('Error cleaning attachment ref:', error);
    }
  },
}
</script>

<style scoped>


.comment-list {
  list-style-type: none;
  padding: 0;
}

.comment-list > .comment > .comment-body {
  margin-top: 20px;
  padding-top: 0;
}

.comment-list > .comment:first-child > .comment-body {
  margin-top: 20px;
}

.comment-list > .comment:last-child > .comment-body {
  margin-bottom: 30px;
}

.comment-content > ul,
.comment-content > ol {
  margin-bottom: 10px;
}

.comment-author .fn {
  font-size: 1.15em;
}

.comment-author .fn,
.comment-author .fn a {
  color: inherit;
  text-decoration: none !important;
}

.comment-author .avatar {
  float: left;
  margin-left: -14px;
  margin-top: -4px;
}

.comment-meta {
  margin-bottom: 1em;
  padding: 5px 15px;
  text-shadow: 0 1px #fff;
  background: rgba(0, 0, 0, 0.01);
  border: 1px solid #32696e;
  border-left-width: 5px;
  -webkit-transition: all 0.6s ease-in-out;
  transition: all 0.6s ease-in-out;
}


@media (min-width: 768px) {

  .comment-body {
    margin-left: 25px;
    padding: 20px 0 20px 25px;
    position: relative;
    border-bottom: 1px dotted #ccc;
    border-left: 1px dotted #ccc;
  }

  .comment-list .children {
    margin-left: 70px;
  }

  .comment-body {
    padding-left: 45px;
  }

  .comment-author .avatar {
    margin-left: -90px;
    margin-top: -6px;
    border: 1px solid #fff;
    border-bottom-width: 4px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  }

  .comment-list > .comment > .comment-body {
    top: 12px;
  }

}

@media (max-width: 767px) {

  .comment-body {
    margin-bottom: 30px;
    border-bottom: 1px solid #ddd;
  }

  .comment-author .avatar {
    margin-right: 15px;
  }

}

</style>
